import { getDeepProperty } from '@/helpers/deepObject.js'
import store from '@/services/store'

// Unless someone is upgrading and are on these routes, a user cannot
// be viewing any dashboard routes in a logged out state
export async function authGuard (to, from) {
  const hasAccessToken = await store.getters.hasAccessToken()
  if (!hasAccessToken) {
    authRedirect(window.location)
    return hasAccessToken
  }

  // RIGHT NOW WE DO NOT HAVE AN ACCOUNT ID IN THE URL, BUT THERE WILL BE A DAY WHEN THIS IS THE CASE
  if (!from.name) {
    const user = await store.dispatch('fetchUser')
    await store.dispatch('getFeatureFlags')

    // Set up Send In Blue identification
    if (user && window.sendinblue) {
      window.sendinblue.identify(user.email)
    }
  }

  const isLoggedIn = await store.getters.isLoggedIn()

  if (!isLoggedIn) {
    authRedirect(window.location)
  }

  return isLoggedIn
}

// When a show that is trying to be accessed is importing, we need to allow only certain routers
// to be accessed.  I had thought about using this in the routes beforeEach, but that would require
// us to maintain a blacklist instead which would invariably be faulty.
export async function importGuard (to, from) {
  const activePodcast = await store.getters.activePodcast
  const activePodcastId = activePodcast.id
  const urlPodcastId = getDeepProperty(to, 'params.podcastId') ? getDeepProperty(to, 'params.podcastId') : activePodcastId
  let currentAccountId = getDeepProperty(store, 'getters.currentAccount.id')

  // Block all routes, but the following whitelist, for importing states
  const importWhitelist = [
    'accounts-billing',
    'accounts-delete-account',
    'accounts-private-apps',
    'accounts-settings',
    'all-shows',
    'create-show',
    'import-show',
    'logout',
    'new-show',
    'orgs-networks',
    'orgs-networks-edit',
    'orgs-networks-new',
    'orgs-users',
    'orgs-users-edit',
    'orgs-users-invite',
    'orgs-users-invited',
    'orgs-users-networks-edit',
    'preview-show',
    'show-importing',
    'verify-show'
  ]

  if (activePodcast && !importWhitelist.includes(to.name)) {
    if (activePodcast.status === 'pending' && activePodcastId === urlPodcastId) {
      if (to.name !== 'verify-show') {
        return {name: 'verify-show', params: {podcastId: activePodcastId, accountId: currentAccountId}}
      }
    } else if (activePodcast.import && activePodcast.import.request && activePodcastId === urlPodcastId) {
      if (to.name !== 'show-importing') {
        return {name: 'show-importing', params: {podcastId: activePodcastId, accountId: currentAccountId}}
      }
    }
  }

  return false
}

export function navGuard (router, to, from) {
  if (!router.options.meta.preventNav || confirm('You have unsaved changes.  Are you sure you want to leave without saving?')) {
    // Clear out value if we make it here
    router.options.meta.preventNav = false

    return true
  }

  return false
}

const authRedirect = (callback) => {
  let redirect = ''

  if (callback) {
    redirect = `?callback=${escape(encodeURI(callback))}`
  }

  window.location = `${process.env.AUTH_BASE_PATH}/login${redirect}`
}
